import {
  typedCollection,
  typedDoc,
  addDoc,
  getCollection,
  updateDocument,
  deleteDocument,
  serverTimestamp,
  type Timestamp,
} from '@/lib/firebase/firestore'

export interface MediaFolderDocument {
  id: string
  name: string
  parentId: string | null
  createdAt: Timestamp
  createdBy: string
}

const foldersCol = () => typedCollection<Omit<MediaFolderDocument, 'id'>>('mediaFolders')

async function createFolder(
  name: string,
  parentId: string | null,
  userId: string
): Promise<string> {
  const docRef = await addDoc(foldersCol(), {
    name,
    parentId,
    createdAt: serverTimestamp() as unknown as Timestamp,
    createdBy: userId,
  })
  return docRef.id
}

async function renameFolder(folderId: string, name: string): Promise<void> {
  await updateDocument(typedDoc<MediaFolderDocument>('mediaFolders', folderId), { name })
}

async function moveFolder(folderId: string, parentId: string | null): Promise<void> {
  await updateDocument(typedDoc<MediaFolderDocument>('mediaFolders', folderId), { parentId })
}

async function deleteFolder(folderId: string): Promise<void> {
  await deleteDocument(typedDoc<MediaFolderDocument>('mediaFolders', folderId))
}

async function getFolders(): Promise<Array<MediaFolderDocument>> {
  return getCollection(foldersCol())
}

export const adminMediaFoldersService = {
  createFolder,
  renameFolder,
  moveFolder,
  deleteFolder,
  getFolders,
}
